import { useEffect } from "preact/hooks"
import { keyEventHandling } from "../util/key-events"
import { ContentType } from "./contents/content-type"
import { Icon } from "./contents/icon"

export const Modal = (data) => {
  useEffect(() => {
    keyEventHandling(window, "Escape", () => {
      data.setModalData({})
    })
  })

  return (
    <dialog
      class={`modal ${data.is_hint ? "hint" : ""} ${data.color || ""}`}
      aria-modal="true"
    >
      <div class="container">
        <button
          type="button"
          class="button modal-close"
          aria-controls="modal"
          onClick={(e) => {
            e.preventDefault()
            data.setModalData({})
          }}
        >
          <Icon name="close" />
        </button>
        {data.contents?.map((obj, i) => {
          return (
            <ContentType {...obj} form={data} key={`modal-${obj.type}-${i}`} />
          )
        })}
      </div>
    </dialog>
  )
}
